import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'ЗАГРУЗКА КМ ИЗ ДОК-ТА',
      title: 'ЗАГРУЗКА КМ ИЗ ДОК-ТА',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Успешно',
      fields: {
        'cisPackageTypeUNIT': 'Тип упаковки КМ',
        'documentId': 'ID документа',
        'packs': 'Упаковки',
        'statusExt': 'Внешний статус',
        'tree': 'Дерево',
        'status': 'Статус',
        'number': 'Номер документа',
        'limit': 'Количество КМ в документе',
        'pageNumber': 'Порядковый номер страницы',
      }
    }
  }
} 